import { Component, input, Input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import {
  TiimeButtonModule,
  TiimeIconModule,
  TiimeInputContainerModule,
  TiimeTableModule,
  TiimeTooltipModule
} from 'tiime-material';

import { ContractAnnexLineCharge } from '@gi/enums/contract-annex-line-charge.enum';
import { ContractAnnexLineForm } from '@gi/forms/contract-annex-line-form';
import { CodeAndLabel } from '@models/code-and-label';
import { ListErrorComponent } from '@shared-components/list-error/list-error.component';
import { DigitOnlyDirective } from '@shared-directives/digit-only/digit-only.directive';
import { CodeAndLabelSelectComponent } from '@shared-selectors/code-and-label-select/code-and-label-select.component';

@Component({
  selector: 'app-contract-annex-line-form-table',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TiimeTableModule,
    TiimeTooltipModule,
    TiimeInputContainerModule,
    CodeAndLabelSelectComponent,
    ListErrorComponent,
    DigitOnlyDirective,
    TiimeIconModule,
    TiimeButtonModule
  ],
  templateUrl: './contract-annex-line-form-table.component.html',
  styleUrls: ['./contract-annex-line-form-table.component.scss']
})
export class ContractAnnexLineFormTableComponent {
  @Input({ required: true }) contractAnnexLineForms: ContractAnnexLineForm[];
  @Input({ required: true }) contractAnnexLineTypes: CodeAndLabel<string>[];
  @Input({ required: true }) contractAnnexLineCharges: CodeAndLabel<ContractAnnexLineCharge>[];
  readonly canRemoveLine: InputSignal<boolean> = input(false);

  readonly removeLine: OutputEmitterRef<number> = output();

  readonly displayedColumns = ['type', 'label', 'chargeChoice', 'discountPercentage', 'actions'];
  readonly ContractAnnexLineCharge = ContractAnnexLineCharge;

  chargeChoiceChange(lineForm: ContractAnnexLineForm): void {
    lineForm.resetDiscountPercentage();
  }

  emitRemoveLine(index: number): void {
    this.removeLine.emit(index);
  }
}
